import { PreLoginKcRealmVO } from '@repo/types/'
import tecsinapse from '@web/assets/tecsinapse.png'
import React, { useState } from 'react'
import { FormProvider } from 'react-hook-form'
import { StageEmail, StageRealm } from '../components'
import { usePreLoginForm } from '../hooks'
import { STAGES } from '../utils'
import { preLoginVariants } from '../styles'

interface PreLoginProps {
  realmParam: string | null
}

const { container, image, stages } = preLoginVariants()

const PreLogin = ({ realmParam }: PreLoginProps) => {
  const form = usePreLoginForm()

  const [stage, setStage] = useState(STAGES.EMAIL)
  const [options, setOptions] = useState<PreLoginKcRealmVO[]>([])

  return (
    <div className={container()}>
      <div className={image()}>
        <img
          className='mr-4'
          src={tecsinapse}
          alt='tecsinapse-logo'
        />
      </div>
      <div className={stages()}>
        <FormProvider {...form}>
          {stage === STAGES.EMAIL ? (
            <StageEmail
              setStage={setStage}
              setOptions={setOptions}
              realmParam={realmParam}
            />
          ) : (
            <StageRealm
              options={options}
              setStage={setStage}
            />
          )}
        </FormProvider>
      </div>
    </div>
  )
}

export default PreLogin
